import { HEADER_THEMES } from '../types';

export const getTextColor = (
  theme: HEADER_THEMES,
  shade: '600' | '900' = '900'
) => {
  switch (theme) {
    // TODO: https://linear.app/republic/issue/USMKT-1457/change-all-hardcoded-colours-for-the-new-hp-to-the-proper-tokens
    case 'new-homepage':
    case 'dark':
      return 'white';
    case 'light':
    case 'r-note-teaser':
    default:
      return `grey.${shade}`;
  }
};
